<template>
  <section :id="id" class="section-wrapper">
    <header class="container section-header">
      <div class="section-header__inner">
        <p v-if="showSubtitle" class="section-eyebrow section-subtitle">{{ sub_title }}</p>
        <h2 class="section-heading section-title darkcolor">{{ title }}</h2>
        <div class="section-header__accent" aria-hidden="true">
          <span class="section-header__line section-header__line--left"></span>
          <span class="section-header__mark"></span>
          <span class="section-header__line section-header__line--right"></span>
        </div>
      </div>
      <div
        v-if="show_selector"
        class="col-sm-12 text-center section-selector"
      >
        <ApartmentSelector
          :selectedApartment="selectedApartment"
          :apartments="apartments"
          @update:selectedApartment="$emit('update:selectedApartment', $event, id)"
        />
      </div>
    </header>
    <div class="section-content">
      <slot />
    </div>
  </section>
</template>

<script>
import ApartmentSelector from '../misc/ApartmentSelector.vue'

export default {
  components: {
    ApartmentSelector
  },
  props: {
    id: String,
    show_selector: Boolean,
    title: String,
    sub_title: String,
    content: String,
    selectedApartment: String,
    apartments: Array
  },
  emits: ['update:selectedApartment'],
  computed: {
    showSubtitle() {
      const subtitle = (this.sub_title || '').trim()
      const heading = (this.title || '').trim()
      if (!subtitle) return false
      return subtitle.localeCompare(heading, 'de', { sensitivity: 'accent' }) !== 0
    }
  }
}
</script>

<style scoped lang="scss">
.section-wrapper {
  padding-top: 36px;
}

.section-header {
  margin-bottom: 28px;
  text-align: center;
}

.section-header__inner {
  max-width: 40rem;
  margin: 0 auto;
  padding: 0 0.5rem;
}

.section-eyebrow {
  margin: 0 0 0.45rem;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: #42d9e4;
  line-height: 1.4;
}

.section-heading {
  margin: 0;
  font-size: clamp(1.875rem, 3.5vw, 2.45rem);
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0.01em;
  text-transform: none;
}

.section-header__accent {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1.15rem;
}

.section-header__line {
  display: block;
  width: clamp(2.5rem, 8vw, 3.75rem);
  height: 1px;
  flex-shrink: 0;

  &--left {
    background: linear-gradient(90deg, transparent 0%, rgba(66, 217, 228, 0.55) 100%);
  }

  &--right {
    background: linear-gradient(90deg, rgba(66, 217, 228, 0.55) 0%, transparent 100%);
  }
}

.section-header__mark {
  display: block;
  width: 0.3125rem;
  height: 0.3125rem;
  flex-shrink: 0;
  border-radius: 50%;
  background: #42d9e4;
  box-shadow: 0 0 0 4px rgba(66, 217, 228, 0.14);
}

.section-selector {
  margin-top: 1.35rem;
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .section-wrapper {
    padding-top: 1.25rem;
  }

  .section-header {
    margin-bottom: 1rem;
  }

  .section-eyebrow {
    font-size: 0.6875rem;
    letter-spacing: 0.18em;
  }

  .section-heading {
    font-size: 1.85rem;
  }

  .section-header__accent {
    gap: 0.625rem;
    margin-top: 0.9rem;
  }

  .section-header__line {
    width: 2.25rem;
  }

  .section-header__mark {
    width: 0.25rem;
    height: 0.25rem;
    box-shadow: 0 0 0 3px rgba(66, 217, 228, 0.12);
  }

  .section-selector {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
}
</style>
